import { FC, useState, Fragment } from 'react'
import { useHighchartsExport } from '@/components/Charts/exporting/HighchartsExportContext'
import { Menu, MenuItem, IconButton } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useTranslation } from 'react-i18next'

const ChartMenu: FC = () => {
    const { actions: exportActions } = useHighchartsExport()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const { t } = useTranslation('site', { keyPrefix: 'dashboard.chartMenu' })

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }
    if (!exportActions?.length) {
        return null
    }

    return (
        <Fragment>
            <IconButton onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {exportActions.map(({ format, downloadHandler }) => (
                    <MenuItem key={format} onClick={downloadHandler}>
                        {t('export', { format })}
                    </MenuItem>
                ))}
            </Menu>
        </Fragment>
    )
}

export default ChartMenu
